import { PartnerType } from 'legacy/lut/classes/models/PartnerType'

import { fetchGlobalPartnerById } from 'clickNgo/services/globalPartner'
import { applyChanges, fetchPartnersByFilter } from 'partner360/components/QBR'

import { IFinancialCockpitQbrDocument } from '../../../api/types'

interface ICreateQbrDocumentArgs {
  partnerId: string
  rtm: PartnerType
}

export const createQbrDocument = async ({
  partnerId,
  rtm,
}: ICreateQbrDocumentArgs): Promise<IFinancialCockpitQbrDocument> => {
  const isGlobalPartner = partnerId.startsWith('GP')
  let partners = [partnerId]
  let name: string | null = null

  if (isGlobalPartner) {
    name = (await fetchGlobalPartnerById(partnerId)).globalPartnerName

    const filter = JSON.stringify({ PartnerIds: [partnerId] })
    const localPartners = await fetchPartnersByFilter(filter)
    if (localPartners.Data.length) {
      partners = localPartners.Data.map((partner) => partner.PartnerID)
    }
  }

  const {
    Data: [qbrDraft],
  } = await applyChanges({
    entryId: null,
    partners,
    rtm,
    name,
    isNoGenerate: false,
    globalPartnerId: isGlobalPartner ? partnerId : null,
  })

  if (!qbrDraft || qbrDraft.EntryId <= 0) {
    throw new Error('QBR draft was created without a valid EntryId')
  }

  return qbrDraft
}
